/**
 * Legacy WordPress uploads. Known brochure PDFs are preserved at their new
 * home under /downloads/; everything else redirects to the homepage.
 */
export const LEGACY_UPLOAD_REDIRECTS: Record<string, string> = {
  "uploads/2023/10/RESTORE_download_Denver_SoftCover_sept_2023_online_v12_1.pdf":
    "/downloads/RESTORE-Hair-Brochure-Colorado.pdf",
  "uploads/2023/10/RESTORE_download_Nationwide_SoftCover_sept_2023_online_v12_1_compressed-1.pdf":
    "/downloads/RESTORE-Hair-Brochure.pdf",
  "uploads/2025/08/restore_presentation_mobile_v26-1.pdf":
    "/downloads/restore_presentation_mobile_v26-1.pdf",
  // Images still used inside migrated blog posts, recovered from the
  // WordPress staging copy on 30 Sep 2026.
  "uploads/2022/04/FUE-NO-SCAR-STRIP-e1651161519818.jpg": "/images/legacy/fue-no-scar-strip.jpg",
  "uploads/2022/04/IMG_7607-1-scaled-e1651161651179.jpg": "/images/legacy/img-7607.jpg",
  "uploads/2022/05/img1-1.jpg": "/images/legacy/img1-1.jpg",
};
